var _path, _path2, _path3, _path4, _ellipse, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoNftcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0698 43.4109H4.92119C4.5663 43.4109 4.27728 43.1201 4.27344 42.7594V5.28617C4.27344 4.92203 4.56342 4.62732 4.92119 4.62732H33.0698C33.4276 4.62732 33.718 4.92205 33.718 5.28617V42.7594C33.7142 43.1201 33.4252 43.4109 33.0698 43.4109ZM5.56259 42.1005H32.4493L32.4498 5.94482H5.56307L5.56259 42.1005Z",
    fill: "#0F0F11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9463 0.0443149H30.9622C31.2181 -0.0553936 28.282 0.0443149 28.0076 0.0443149C26.7766 0.0443149 31.1469 0.0443149 24.7453 0.0443149L21.9138 0.0443182C20.6212 0.0443149 24.376 0.0443153 20.0894 0.0443149C19.0823 0.0443286 17.3588 1.24965 18.159 1.35481C17.71 1 20.1595 0.0442859 20.1595 0.0442859C20.0364 0.0442861 20.4981 0.0443149 20.1595 0.0442859L3.05413 0.0443149C2.24432 0.0443149 1.46715 0.3713 0.894452 0.953412C0.321754 1.53552 0 2.32539 0 3.14845V44.8959C0.00192356 45.7185 0.324119 46.5069 0.896866 47.089C1.46912 47.6706 2.24477 47.9981 3.05408 48H34.9464C35.7557 47.998 36.5314 47.6706 37.1036 47.089C37.6759 46.5068 37.9986 45.7185 38 44.8959V3.14845C38 2.32538 37.6783 1.53549 37.1055 0.953412C36.5328 0.371337 35.7561 0.0443149 34.9463 0.0443149ZM36.7116 44.8955C36.7131 45.3725 36.5279 45.8305 36.1971 46.1682C35.8658 46.5064 35.4156 46.6961 34.9468 46.6961H3.05448C2.58657 46.6961 2.13742 46.5074 1.80653 46.1707C1.47568 45.8344 1.28958 45.3784 1.28958 44.9023V3.14858C1.28958 2.67301 1.47568 2.21651 1.80653 1.8802C2.13739 1.54389 2.58653 1.35478 3.05448 1.35478C3.05448 1.35478 12.2603 1.35481 18.159 1.35481C18.3032 1.35481 18.5283 1.35478 18.5283 1.35478C19.3478 1.35478 19.4918 1.34257 19.766 1.35478H20.0894H34.9461C35.414 1.35478 35.8626 1.54393 36.194 1.8802C36.5249 2.21647 36.711 2.67297 36.711 3.14858L36.7116 44.8955Z",
    fill: "#0F0F11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8505 32.5999L13.2125 20.7714L4.91992 29",
    stroke: "#0F0F11",
    strokeWidth: 1.31429
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2842 27.8L24.4788 22.7258L32.9606 31.5",
    stroke: "#0F0F11",
    strokeWidth: 1.31429
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.9585,
    cy: 15.8,
    rx: 1.771,
    ry: 1.8,
    fill: "#0F0F11"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.95167,
    height: 1.32,
    transform: "matrix(1 0 0 -1 17.71 1.35999)",
    fill: "#0F0F11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNftcard);
export default __webpack_public_path__ + "static/media/ico-nftcard.1cecb379eb7d18005d4355e03fe95489.svg";
export { ForwardRef as ReactComponent };